// @mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
// Iconify
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content: React.ReactNode;
  actionLabel?: string;
  icon?: string;
  iconSize?: number;
}

export default function AlertDialog({
  open,
  onClose,
  title,
  content,
  actionLabel,
  icon,
  iconSize = 40,
}: SuccessDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {icon && (
            <Iconify icon={icon} sx={{ fontSize: iconSize, mr: 1 }} />
          )}
          {title}
        </Box>
      </DialogTitle>

      <DialogContent sx={{ color: 'text.secondary' }}>
        {content}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose} autoFocus>
          {actionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
 